import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { SUPPORTED_LANGUAGES, setLanguage } from '@/lib/i18n';

/**
 * Full-screen language picker shown on first launch (desktop Setup wizard).
 * Displays all 7 languages in their native script. Tapping a row sets the
 * app-wide locale via setLanguage() and calls onSelect(code).
 */
export default function LanguagePicker({ onSelect }) {
  const { t } = useTranslation();

  const handlePick = (code) => {
    setLanguage(code);
    if (onSelect) onSelect(code);
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-8"
      style={{ background: 'linear-gradient(160deg, #EEF2FF 0%, #fff 40%, #FFF7ED 100%)' }}
    >
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div
            className="w-14 h-14 rounded-xl flex items-center justify-center mx-auto mb-4"
            style={{ background: 'linear-gradient(135deg, #4F46E5, #6366F1)' }}
          >
            <Globe size={24} className="text-white" />
          </div>
          <h1 className="text-2xl font-bold text-brand-dark mb-1">
            {t('common:language.picker_title')}
          </h1>
          <p className="text-sm text-gray-500">
            {t('common:language.picker_subtitle')}
          </p>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 divide-y divide-gray-100 shadow-sm overflow-hidden">
          {SUPPORTED_LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handlePick(lang.code)}
              className="w-full flex items-center justify-between px-5 py-4 hover:bg-gray-50 transition-colors text-left"
            >
              <span className="text-base font-medium text-gray-900">{lang.native}</span>
              <span className="text-xs text-gray-400 uppercase tracking-wider">{lang.code}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
